import { Capacitor } from '@capacitor/core';
import { Box, Slide, useTheme } from '@mui/material';
import { PropsWithChildren, ReactElement, ReactNode } from 'react';

import { ConditionalWrap } from '@frontend-libs/atomic';

export interface AppBottomActionBarProps {
  slideEnabled?: boolean;
  slideCondition?: boolean;
}

export const AppBottomActionBar = (
  props: PropsWithChildren<AppBottomActionBarProps>,
) => {
  const theme = useTheme();
  return (
    <ConditionalWrap
      condition={props.slideEnabled ?? false}
      wrap={(children) => (
        <Slide
          in={props.slideCondition !== undefined ? props.slideCondition : true}
          direction="up"
        >
          {children as ReactElement<ReactNode>}
        </Slide>
      )}
    >
      <Box
        sx={{
          width: '100%',
          bottom: 0,
          left: 0,
          right: 0,
          position: 'fixed',
          backgroundColor: theme.palette.background.paper,
          zIndex: theme.zIndex.drawer + 2,
          pb: Capacitor.isNativePlatform()
            ? 'var(--safe-area-inset-bottom)'
            : undefined,
        }}
        display="flex"
        justifyContent="center"
      >
        <Box
          sx={{
            borderTop: `1px solid ${theme.palette.divider}`,
            p: 2,
            pb: 3,
            width: '100%',
            maxWidth: '100%',
          }}
        >
          {props.children}
        </Box>
      </Box>
    </ConditionalWrap>
  );
};
